import { RouterProvider } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { OpenFeatureProvider } from '@openfeature/react-sdk';
import { router } from './router';
import { ThemeProvider } from './components/providers/theme-provider';
import { queryClient } from './lib/query';
import { Show } from '@/components/shared';

export const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <OpenFeatureProvider>
          <RouterProvider router={router} />
        </OpenFeatureProvider>
      </ThemeProvider>
      <Show when={import.meta.env.DEV}>
        <ReactQueryDevtools initialIsOpen={false} />
      </Show>
    </QueryClientProvider>
  );
};
